// extracted by mini-css-extract-plugin
module.exports = {"feature":"FeaturesItemBlock_feature__m6y0D","title":"FeaturesItemBlock_title__bRFqY"};